export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/7e73e16ebbcf336fd539cd4c32a2dc9c.svg";